// src/components/BookingPageShell.jsx
import React from "react";
import PropTypes from "prop-types";
import "../styles/BookingShell.css";

const BookingPageShell = ({ title, isAdmin, controls, children, stats }) => {
  return (
    <main className="booking-shell">
      <header className="booking-shell-header">
        <div className="booking-shell-left">
          <h1 className="booking-shell-title">
            {title}
            {isAdmin && <span className="admin-badge">Admin</span>}
          </h1>

          {stats && (
            <div className="booking-shell-stats">
              {stats}
            </div>
          )}
        </div>

        <div className="booking-shell-controls">
          {controls}
        </div>
      </header>

      <section className="booking-shell-content">
        {children}
      </section>
    </main>
  );
};

BookingPageShell.propTypes = {
  title: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool,
  controls: PropTypes.node,
  stats: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default BookingPageShell;
